'use strict'

module.exports = value => (value == null ? '' : value.toString())



// WEBPACK FOOTER //
// ./helpers/convertValueToString.js